import Vue from 'vue';

const FormatKiB = {
  install(): void {
    Vue.prototype.formatKiB = (kib: number | null | undefined): string => {
      if (kib === null || kib === undefined) {
        return '0';
      }

      // KiB to MB
      const mb = kib / 976.6;

      // If less than 1 GB -show in MB
      if (mb < 1000) {
        return `${Math.round(mb)} MB`;
      }

      // 1 GB or more - show in GB with 2 decimal
      const gb = mb / 1000;
      return `${gb.toFixed(2)} GB`;
    };
  },
};

export default FormatKiB;
